import axios from '@/lib/axios';
import { SalesOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1250. 受注案件アーカイブ
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/archive
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const archiveSalesOrder = (props: Props): Promise<SalesOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/archive`, props);
};

export const useArchiveSalesOrder = () => {
  return useMutation({
    mutationFn: archiveSalesOrder,
  });
};
